<template>
  <router-view v-if="mobileView" mobile-view />
  <div v-else id="app-wrapper">
    <div class="container-slim">
      <sdui-general v-if="defer(3)" />

      <!-- CONTENT -->
      <RouterView />

      <!-- FOOTER MENU AND NAV-->
      <sdui-nav-bar v-if="defer(2)" />
    </div>

    <sdui-alert-modals />
  </div>
</template>
<script>
import SduiGeneral from 'src/layout/SduiGeneral.vue'
import SduiAlertModals from 'src/layout/SduiAlertModals.vue'
import SduiNavBar from 'src/layout/SduiNavBar.vue'
import Defer from 'src/mixins/miscellaneous/defer.js'
import isMobileDeviceMixin from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'

export default {
  name: 'Sdui',
  components: {
    SduiGeneral,
    SduiAlertModals,
    SduiNavBar,
  },

  mixins: [Defer(), isMobileDeviceMixin],

  data: () => ({}),

  computed: {
    mobileView() {
      return this.$route.meta?.mobileView && this.hasMobileSize
    },
  },
}
</script>

<style scoped lang="scss">
#app-wrapper {
  /** Offset for bottom navigation: */
  padding-bottom: 100px; // for old browsers where `env` is not supported
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  padding-top: 60px;

  &.with-alert {
    padding-bottom: 150px;
    padding-bottom: calc(150px + env(safe-area-inset-bottom));
  }
}

.reset-button {
  color: inherit !important;
}
</style>
